import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import BasicText from '../../../Theme/Fonts/BasicText'

type Props = {
    caption: string
}

export const TeaserCaption = ({ caption }: Props): ReactElement => (
    <Grid noExpand marginTop={4}>
        <BasicText
            color="keshi-3"
            fontSize={['FS12', 'FS12', 'FS14', 'FS16']}
            lineHeight={['LH16', 'LH16', 'LH20', 'LH22']}
        >
            {caption}
        </BasicText>
    </Grid>
)
